module.exports = __webpack_public_path__ + "static/media/E-shield.b851e612.png";